import { useEffect, useState } from 'react'
import i18n from '@/i18n'
import CustomCollectionsService from '@/services/CustomCollectionsServiceNew'
import SingleCustomCollectionService from '@/services/SingleCustomCollectionService'

export default function useEditFormData({ collectionId, itemId }) {
    const [collectionDetails, setCollectionDetails] = useState(null);
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const setFieldValue = (fieldName, value) => {
        // console.log(`TCL -> useEditFormData.js:12 -> setFieldValue -> fieldName, value:`, fieldName, value)
        setFormData(prevData => ({
            ...prevData,
            [fieldName]: value,
        }));
    };

    const loadFormData = async () => {
        setLoading(true);
        setError(null);

        try {
            const collectionResult = await CustomCollectionsService.getCustomCollectionById(collectionId);
            // console.log(`TCL -> useEditFormData.js:24 -> loadFormData -> collectionResult:`, collectionResult)
            if (collectionResult.error) {
                setError(i18n.t('singleCustomCollection.form.messages.fetchCollectionError', { error: collectionResult.error }));
                setLoading(false);
                return;
            }
            setCollectionDetails(collectionResult.data);

            if (itemId) {
                const itemResult = await SingleCustomCollectionService.getCustomCollectionItemById(collectionResult.data?.name, itemId);
                if (itemResult.error) {
                    setError(i18n.t('singleCustomCollection.form.messages.fetchItemError', { error: itemResult.error }));
                    setLoading(false);
                    return;
                }
                delete itemResult.data._id;
                delete itemResult.data.__v;
                delete itemResult.data.created;
                delete itemResult.data.updated;
                setFormData(itemResult.data);
                // console.log(`TCL -> useEditFormData.js:40 -> loadFormData -> itemResult.data:`, itemResult.data)
            } else {
                setFormData({});
            }
        } catch (err) {
            console.error('Error loading form data:', err);
            setError(i18n.t('singleCustomCollection.form.messages.loadFailed'));
        } finally {
            setLoading(false);
        }
    };

    const saveFormData = async () => {
        setLoading(true);
        setError(null);

        try {
            let result;
            if (itemId) {
                result = await SingleCustomCollectionService.updateCustomCollectionItem(collectionDetails.name, itemId, formData);
            } else {
                const payload = { ...formData, collection: collectionDetails?.name };
                result = await SingleCustomCollectionService.createCustomCollectionItem(payload);
            }

            if (result.error) {
                setError(i18n.t('singleCustomCollection.form.messages.saveError', { error: result.error }));
                setLoading(false);
                return { data: null, error: result.error };
            }

            return { data: result.data, error: null };
        } catch (err) {
            console.error('Error saving form data:', err);
            const message = i18n.t('singleCustomCollection.form.messages.saveFailed');
            setError(message);
            return { data: null, error: message };
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadFormData();
    }, [collectionId, itemId]);

    return {
        collectionDetails,
        formData,
        loading,
        error,
        saveFormData,
        setFieldValue,
    }

}
